/**
 * 全站http配置
 *
 * axios参数说明
 * isSerialize是否开启form表单提交
 * isToken是否需要token
 */
import axios from 'axios'
import { serialize } from "@/utils/util";
import { getLocal } from "@/utils/store";
import { Toast } from 'vant'

//返回其他状态吗
axios.defaults.validateStatus = function (status) {
  return status >= 200 && status <= 500; // 默认的
};

//跨域请求，允许保存cookie
// axios.defaults.withCredentials = false;


//HTTPrequest拦截
axios.interceptors.request.use(config => {
  const meta = (config.meta || {});
  const isToken = meta.isToken === false;

  if (getLocal({name:'token'}) && !isToken) {
    config.headers.Authorization = getLocal({name:'token'}) // 让每个请求携带token--['Authorization']为自定义key 请根据实际情况自行修改
  }
  //headers中配置serialize为true开启序列化
  if (config.method === 'post' && meta.isSerialize === true) {
    config.data = serialize(config.data);
  }
  return config
}, error => {
  return Promise.reject(error)
});

//HTTPresponse拦截
axios.interceptors.response.use(res => {
  const status = Number(res.status) || 200;
  const statusWhiteList = [400];
  const message = res.data.message || '未知错误';

  //如果在白名单里则自行catch逻辑处理
  if (statusWhiteList.includes(status)) return Promise.reject(res.data.message);

  // 如果请求为非200否者默认统一处理
  if (status > 300) {
    return Promise.reject(message);
  }
  
  return res.data;
}, error => {
  return Promise.reject(new Error(error));
})

export default axios;